var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { formatFreebetDate } from './utils';
var messages = defineMessages({
    use_freebet: {
        id: 'coupon.use_freebet',
        defaultMessage: 'Использовать фрибет'
    },
    valid_until: {
        id: 'coupon.freebet_valid_until',
        defaultMessage: 'Действует до {date}'
    },
    no_limit: {
        id: 'profile.freebet.no_limit',
        defaultMessage: 'Без ограничения срока'
    }
});
var formatDate = function (dateTimeString) { return formatFreebetDate(dateTimeString).split(',')[0]; };
var FreebetButton = /** @class */ (function (_super) {
    __extends(FreebetButton, _super);
    function FreebetButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false
        };
        _this.onDocumentClick = function (e) {
            if (_this.state.open && _this.root && !_this.root.contains(e.target)) {
                _this.setState({ open: false });
            }
        };
        _this.toggleOpen = function () {
            if (_this.props.freebets.length < 2 || !_this.props.freebetToggled) {
                return;
            }
            _this.setState({ open: !_this.state.open });
        };
        _this.onSelect = function (id) {
            _this.props.selectFreebet(id);
            _this.setState({ open: false });
        };
        return _this;
    }
    FreebetButton.prototype.componentDidMount = function () {
        document.addEventListener('click', this.onDocumentClick);
    };
    FreebetButton.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.onDocumentClick);
    };
    FreebetButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, freebets = _a.freebets, selectedFreebetId = _a.selectedFreebetId, accountResourceName = _a.accountResourceName, toggleFreebet = _a.toggleFreebet, freebetToggled = _a.freebetToggled;
        var open = this.state.open && freebetToggled;
        var selected = freebets.find(function (item) { return item.id === selectedFreebetId; }) || freebets[0];
        var single = freebets.length < 2;
        var disabled = single || !freebetToggled;
        return (_jsx("div", __assign({ className: 'freebet' }, { children: _jsxs("div", __assign({ className: 'term remember_me' }, { children: [_jsx("input", { name: 'toggle-freebet', id: 'toggle-freebet', type: 'checkbox', readOnly: true, checked: freebetToggled }), _jsx("label", __assign({ htmlFor: 'toggle-freebet', onClick: toggleFreebet }, { children: _jsx(FormattedMessage, __assign({}, messages.use_freebet)) })), _jsxs("div", __assign({ className: 'freebet__dropdown', ref: function (node) { return _this.root = node; } }, { children: [_jsxs("button", __assign({ type: 'button', className: "freebet__dropdown-toggle".concat(open ? ' open' : '').concat(disabled ? ' disabled' : ''), onClick: this.toggleOpen }, { children: [_jsxs("span", { children: [selected.amount, " ", accountResourceName] }), !single && _jsx("i", { className: 'freebet__dropdown-arrow' })] })), open &&
                                _jsx("ul", __assign({ className: 'freebet__dropdown-list' }, { children: freebets.map(function (item) { return (_jsxs("li", __assign({ className: "freebet__dropdown-item".concat(item.id === selected.id ? ' selected' : ''), onClick: function () { return _this.onSelect(item.id); } }, { children: [_jsx("span", { className: 'freebet__dropdown-radio' }), _jsxs("span", __assign({ className: 'freebet__dropdown-info' }, { children: [_jsxs("span", __assign({ className: 'freebet__dropdown-amount' }, { children: [item.amount, " ", accountResourceName] })), _jsx("span", __assign({ className: 'freebet__dropdown-date' }, { children: item.endDate
                                                            ? _jsx(FormattedMessage, __assign({}, messages.valid_until, { values: { date: formatDate(item.endDate) } }))
                                                            : _jsx(FormattedMessage, __assign({}, messages.no_limit)) }))] }))] }), item.id)); }) }))] }))] })) })));
    };
    return FreebetButton;
}(React.Component));
FreebetButton.propTypes = {
    freebets: PropTypes.array.isRequired,
    selectedFreebetId: PropTypes.number,
    freebetToggled: PropTypes.bool.isRequired,
    accountResourceName: PropTypes.any,
    toggleFreebet: PropTypes.func.isRequired,
    selectFreebet: PropTypes.func.isRequired
};
export default FreebetButton;



// WEBPACK FOOTER //
// ./src/components/coupon/FreebetButton.jsx